module.exports = __webpack_public_path__ + "media/vid_top_case3.af9ca255.mp4";